import React from "react";
import categories from "../Courses/Categories";
import noblog from "./img/404.png";
import "./css/Blog.css";

function Blog() {
  return (
    <div className="course-category">
      <div className="course-category-main">
        <div className="course-category-select">
          <p>Select blog category</p>

          <div className="course-category-options">
            {categories.map((data) => (
              <div
                // onClick={() => handleCategory(data.id, data.content)}
                className="course-category-option"
              >
                <p>{data.name}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="blogs">
          <div className="blogs-content">
            <img src={noblog} alt="404 - not found" />
            <h3>Wait some time we are adding content very soon...</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;
